export type EntityType = "session" | "resource" | "user" | "registration";

export interface RecentActivityItem {
    entityType: EntityType;
    entityId: string;
    entityName: string;
    subtitle?: string;
    lastAccessedUtc: string;
    eventType: string;
}

export interface RecentActivityResponseDto {
    sessions: RecentActivityItem[];
    resources: RecentActivityItem[];
    users: RecentActivityItem[];
    registrations: RecentActivityItem[];
}

/**
 * Builds the detail page URL for a given entity type and ID.
 * For users, also requires email to build the query string URL.
 * For resources, entityId should be the pkey (not imKey).
 */
export function buildDetailUrl(entityType: EntityType, entityId: string, email?: string): string {
    switch (entityType) {
        case "session":
            return `/session/${entityId}`;
        case "resource":
            // entityId is the pkey for resources
            return `/resource/${entityId}/0`;
        case "user":
            return `/user/?email=${encodeURIComponent(email ?? "")}&imkey=${entityId}`;
        case "registration":
            return `/registration/${entityId}`;
        default:
            return "/";
    }
}
